import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram, Facebook, Phone, MessageCircle } from 'lucide-react';

const LOGO_URL = "/logo.jpeg";

const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61561000261625";
const INSTAGRAM_URL = "https://www.instagram.com/ananskitchenbristol/";
const GMAIL_ADDRESS = "ananskitchenbristol@gmail.com";
const WHATSAPP_URL = "https://wa.me/4407827893614?text=Hi%20ANAN's%20Kitchen!%20I'd%20like%20to%20know%20more%20about%20your%20meal%20plans.";

export default function Footer() {
  return (
    <footer className="bg-[#2C402E] text-white" data-testid="footer">
      {/* Referral Banner */}
      <div className="bg-[#E05D3A] overflow-hidden">
        <div className="animate-marquee whitespace-nowrap py-3 flex">
          {[...Array(4)].map((_, i) => (
            <span key={`marquee-${i}`} className="mx-8 text-sm font-medium text-white">
              REFER A FRIEND & GET £10 OFF • REFER 25 FRIENDS = FREE FOOD FOR A MONTH •
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="ANAN's Kitchen" className="w-11 h-11 rounded-full object-cover" />
              <div>
                <h3 className="font-serif font-bold text-xl">ANAN's Kitchen</h3>
                <p className="text-xs text-[#D4AF37]">Healthy You</p>
              </div>
            </div>
            <p className="text-[#FAF6F0]/70 text-sm leading-relaxed">
              Healthy meals delivered to your doorstep in Bristol. Fresh, nutritious, and delicious - every single day.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#FAF6F0]/70 hover:text-[#E05D3A] text-sm transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/menu" className="text-[#FAF6F0]/70 hover:text-[#E05D3A] text-sm transition-colors">
                  Weekly Menu
                </Link>
              </li>
              <li>
                <Link to="/subscribe" className="text-[#FAF6F0]/70 hover:text-[#E05D3A] text-sm transition-colors">
                  Subscribe
                </Link>
              </li>
              <li>
                <Link to="/puzzle" className="text-[#FAF6F0]/70 hover:text-[#E05D3A] text-sm transition-colors">
                  Monthly Puzzle
                </Link>
              </li>
              <li>
                <Link to="/allergens" className="text-[#FAF6F0]/70 hover:text-[#E05D3A] text-sm transition-colors">
                  Allergen Info
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm">
                <Phone className="w-4 h-4 text-[#E05D3A]" />
                <a href="tel:07827893614" className="text-[#FAF6F0]/70 hover:text-[#E05D3A] transition-colors">
                  07827 893 614
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <MessageCircle className="w-4 h-4 text-[#25D366]" />
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-[#FAF6F0]/70 hover:text-[#25D366] transition-colors">
                  Chat on WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Mail className="w-4 h-4 text-[#E05D3A]" />
                <a href={`mailto:${GMAIL_ADDRESS}`} className="text-[#FAF6F0]/70 hover:text-[#E05D3A] transition-colors">
                  {GMAIL_ADDRESS}
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#FAF6F0]/70 text-sm">
                <MapPin className="w-4 h-4 text-[#E05D3A] mt-0.5" />
                <span>Bristol, United Kingdom</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-serif font-semibold text-lg mb-4">Follow Us</h4>
            <p className="text-[#FAF6F0]/70 text-sm mb-4">
              Stay updated with our latest meals and winner announcements!
            </p>
            <div className="flex gap-3">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#25D366]/20 flex items-center justify-center hover:bg-[#25D366] transition-colors" data-testid="footer-whatsapp">
                <MessageCircle className="w-5 h-5" />
              </a>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#FAF6F0]/10 flex items-center justify-center hover:bg-[#E05D3A] transition-colors" data-testid="footer-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#FAF6F0]/10 flex items-center justify-center hover:bg-[#E05D3A] transition-colors" data-testid="footer-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={`mailto:${GMAIL_ADDRESS}`} className="w-10 h-10 rounded-full bg-[#FAF6F0]/10 flex items-center justify-center hover:bg-[#E05D3A] transition-colors" data-testid="footer-gmail">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#FAF6F0]/10 mt-12 pt-8 text-center text-[#FAF6F0]/50 text-sm">
          <p>&copy; {new Date().getFullYear()} ANAN's Kitchen. All rights reserved. Healthy Food, Healthy You.</p>
        </div>
      </div>
    </footer>
  );
}
